import SearchBar from "./SearchBar.js";
export default {
  id: 'rsrc.dataViewer.search.ImagineRsrcSearchBar',
  type: 'imagineRsrc.Search',
  name: 'Search Bar',
  icon: 'fa fa-search fa-fw',
  location: ['search'],
  matches: {
    type: 'GroupDataViewer',
    objectType: 'rsrc'
  },
  component: SearchBar
};